import { ref, computed } from "vue";

const width = ref(window.innerWidth);

/** Is Mobile */
export const isMobile = computed(() => width.value <= 768);

/** Is Desktop */
export const isDesktop = computed(() => width.value > 768);

/** Is Tablet */
export const isTablet = computed(() => width.value > 768 && width.value <= 1024);

/** Device Type */
export const deviceType = computed(() => (isMobile.value ? "mobile" : "desktop"));

/** Device Type */
type UseDeviceResult = {
  isMobile: typeof isMobile;
  isDesktop: typeof isDesktop;
  isTablet: typeof isTablet;
  deviceType: typeof deviceType;
};

let init = false;

/** Use Device */
export const useDevice = (): UseDeviceResult => {
  if (!init) {
    init = true;
    window.addEventListener("resize", () => {
      width.value = window.innerWidth;
    });
  }
  return { isMobile, isDesktop, isTablet, deviceType };
};
